import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { useContent } from "@/context/ContentContext";
import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { TEAM } from "@/lib/company";

export default function Team() {
  const { t } = useLanguage();
  const { content } = useContent();
  const team =
    content?.team ??
    TEAM.map((m) => ({ name: m.name, role: t.teamPage[m.roleKey], photo: m.photo }));

  return (
    <div data-testid="team-page">
      <PageHeader
        overline={t.teamPage.overline}
        title={t.teamPage.title}
        subtitle={t.teamPage.subtitle}
      />

      <section className="bg-white">
        <div className="mx-auto max-w-7xl px-6 py-20 lg:px-10 lg:py-28">
          <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {team.map((m, i) => (
              <Reveal key={m.name} delay={(i % 3) * 0.06}>
                <div
                  className="group border border-[#E5E5E5] transition-colors duration-200 hover:border-[#E8620E]"
                  data-testid={`team-member-${i}`}
                >
                  <div className="aspect-[4/5] overflow-hidden bg-[#F0F0F2]">
                    <img
                      src={m.photo}
                      alt={m.name}
                      loading="lazy"
                      className="h-full w-full object-cover object-top grayscale transition-all duration-500 group-hover:scale-[1.03] group-hover:grayscale-0"
                    />
                  </div>
                  <div className="border-t border-[#E5E5E5] p-6">
                    <h3 className="text-lg font-medium tracking-tight text-[#0A0A0A]">
                      {m.name}
                    </h3>
                    <p className="mt-2 text-sm leading-relaxed text-[#E8620E]">
                      {m.role}
                    </p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
